export default __webpack_public_path__ + "static/media/instant_deployment_icon.aed51659.svg";